import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  ActivityIndicator,
  StyleSheet,
  Platform,
  Alert,
  Linking,
} from "react-native";
import { api, axios } from "components/helpers/api";
import { Feather } from "@react-native-vector-icons/feather";

const openPdf = async ({ url, filename }) => {
  if (!url) {
    Alert.alert("Unable to open PDF", "No file URL available.");
    return;
  }

  try {
    if (Platform.OS === "web") {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      await Linking.openURL(url);
    }
  } catch (err) {
    Alert.alert("Unable to open PDF", filename || "This PDF could not be opened.");
  }
};

const PatientRecords = ({ patient }) => {
  const _theme = window.main.theme;
  const [loading, setLoading] = useState(true);
  const [vaccineRecords, setVaccineRecords] = useState(null);
  const [medicalRecords, setMedicalRecords] = useState(null);

  async function fetchRecords(patient_id) {
    setLoading(true);
    try {
      if (unmounted) {
        return;
      }
      // const [patRecResult, patVaccResult] = await Promise.allSettled([
      //   axios.get(api.getPatientRecordsPdf.replace("{patient_id}",patient.patient_id)),
      //   axios.get(api.getPatientVaccsPdf.replace("{patient_id}",patient.patient_id)),
      // ]);
      // setVaccineRecords(patRecResult);
      // setMedicalRecords(patVaccResult);
      setLoading(false);
    } catch {
      if (!unmounted) {
        setVaccineRecords(null);
        setMedicalRecords(null);
      }
    } finally {
      if (!unmounted) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (!patient?.patient_id) {
      return;
    }
    let unmounted = false;
    // fetchRecords(patient.patient_id);
    return () => {
      unmounted = true;
    };
  }, [patient]);

  return (
    <View style={styles.container}>
      <Text style={{...styles.mainTitle,color:_theme.colors.mode.textColor}}>
        Patient Records
      </Text>
      {/* <TouchableOpacity style={styles.recordRow} onPress={()=>{openPdf({url:localVaccinePDFPath,filename:"shot_records.pdf"});}}> */}
      <View style={styles.recordRow}>
        <Feather name="file-text" size={18} style={styles.recordIcon} />
        <Text style={styles.recordText}>Patient Records PDF</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 18,
    paddingTop: 14,
    borderTopWidth: 1,
    borderTopColor: "#e6e6e6",
  },
  mainTitle: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 10,
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: "bold",
    marginTop: 10,
    marginBottom: 8,
  },
  recordRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 8,
  },
  recordIcon: {
    marginRight: 8,
    color: "#444",
  },
  recordText: {
    fontSize: 14,
    color: "#222",
  },
  recordDate: {
    color: "#888",
  },
  emptyText: {
    color: "#777",
    fontSize: 14,
    marginBottom: 6,
  },
});

export default PatientRecords;